import React from "react";

interface SearchResultsContainerProps {
    children?: React.ReactNode;
    className?: string;
    title?: string;
}

export const SearchResultsContainer: React.FC<SearchResultsContainerProps> = ({
    children,
    className = "",
    title = "Search Results",
}) => {
    const containerClass = `search-results-container${className ? ` ${className}` : ""}`;

    return (
        <div className={containerClass}>
            <div className="search-results-container__header">
                <span>{title}</span>
            </div>
            <div className="search-results-container__content">
                {children}
            </div>
        </div>
    );
};
